/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const TRANSITION = {
  default: "0.2s ease-in-out",
} as const;
